import { PostType } from "@/core/types/contentTypes";
import { useAppSelector } from "@/core/store/reduxHooks";
import { PostsSelector } from "@/core/store/bucket/BucketSlice";
import useLangSelector from "@/core/dataProviders/hooks/useLangSelector";

/**
 * returns full data from list of IDs
 * */

const usePostsFiller = (): ((ids: number[]) => PostType[]) => {
  const posts = useLangSelector(useAppSelector(PostsSelector));

  // filter only available posts, .then
  // map id to postId
  return (ids: number[]): PostType[] => {
    return posts ? ids.filter((id: number): boolean => !!posts[id]).map((id: number): PostType => posts[id]) : [];
  };
};

export default usePostsFiller;
